import { Button, Types } from '@marriott/mi-ui-library';
import { BrgModelProps } from './BrgClaimForm.types';

export function BrgUnAuth({ authRequiredSection, pageTitle, pageFormDescription }: BrgModelProps) {
  return (
    <div className="container">
      <div className="brg-container">
        <h1 className="t-title-m t-font-weight-m">{pageTitle}</h1>
        <p>{pageFormDescription}</p>
        <hr />
        <p>{authRequiredSection?.signInRequiredMessage}</p>
        <Button
          className="m-button-primary center-button"
          isLink={true}
          type={Types.ButtonTypeVariation.Button}
          href={authRequiredSection?.signInURL}
          testId="brg-signin-button"
        >
          {authRequiredSection?.signInButtonLabel}
        </Button>
      </div>
    </div>
  );
}
